import { z } from 'zod';
import { dateSchema, quantitySchema } from '../../validation';

export const agreementDatesSchema = z.object({
  /** the start date of the agreement */
  start: dateSchema,
  /** the end date of the agreement */
  end: dateSchema,
  /** the duration of the agreement in days which is basically the difference between the start and end date */
  durationInDays: quantitySchema,
  /** auto renew means when the agreement is about to end, then auto renew it with the same duration */
  autoRenew: z.boolean(),
});
